let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9XR1b")).then(() => parcelRequire('2BBoC'));